module.exports = __webpack_public_path__ + "static/service-1-3b4ca1b64ad54af7ff7a93fe43276862.svg";